
window.$ = window.jQuery = require('jquery');

window.Swal = require('sweetalert2')

require('./validation_helper');
require('./dialogs/confirm_dialog');
require('./dialogs/loading_dialog');
require('./web_function');

import 'bootstrap';
import 'moment';
import 'slick-carousel';
import 'jquery-validation';
import 'jquery-validation/dist/additional-methods';

import Swiper, { Navigation,Pagination,EffectFade,Autoplay } from 'swiper';
import 'swiper/css/effect-fade';

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {ScrollToPlugin} from 'gsap/ScrollToPlugin';
import {Draggable} from 'gsap/Draggable';

import lottie from 'lottie-web';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(Draggable);

window.Swiper         = Swiper;
window.Navigation     = Navigation;
window.Pagination     = Pagination;
window.Autoplay       = Autoplay;
window.EffectFade     = EffectFade;

window.gsap           = gsap;
window.ScrollTrigger  = ScrollTrigger;
window.ScrollToPlugin = ScrollToPlugin;
window.Draggable      = Draggable;

window.lottie         = lottie;
